import { useState, useEffect, useContext } from "react";
import {
  Grid,
  Typography,
  Checkbox,
  Menu,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { EventContext } from "../../../contexts/EventContext";
import EditProfileDialog from "../../../components/EditProfileDialog";
import SwapDialog from "./SwapDialog";
import TransferDialog from "./TransferDialog";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import request from "../../../utilities/requests";
import { toast } from "../../../utilities/SnackBarUtils";

const AttendeeList = () => {
  const {
    userData,
    pairingEvent,
    attendees,
    setAttendees,
    percentages,
    setPercentages,
  } = useContext(EventContext);
  const [menuOpen, setMenuOpen] = useState(false);
  const [anchor, setAnchor] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [editUserOpen, setEditUserOpen] = useState(false);
  // const [confirmOpen, setConfirmOpen] = useState(false);
  const [removeUserOpen, setRemoveUserOpen] = useState(false);
  const [swapOpen, setSwapOpen] = useState(false);
  const [transferOpen, setTransferOpen] = useState(false);
  const [ticketingEnabled, setTicketingEnabled] = useState(false);

  useEffect(() => {
    if (userData?.org?.config?.ticketingEnabled) {
      setTicketingEnabled(true);
    }
  }, [userData]);

  const handleCheck = (i) => {
    if (!attendees[i].checkedIn) {
      attendees[i].checkedIn = true;
      updpateCheckinStatus(attendees[i]._id, true);
    } else {
      attendees[i].checkedIn = false;
      updpateCheckinStatus(attendees[i]._id, false);
    }
    setAttendees([...attendees]);
  };

  const updpateCheckinStatus = async (userId, checkedIn) => {
    const body = {
      eventId: pairingEvent.event._id,
      userId,
      checkedIn,
    };
    const result = await request("events/updatecheckin", "post", body);
    if (!result.success) {
      alert(result.error);
    }
  };

  const handleMenuOpen = (event, item) => {
    setAnchor(event.currentTarget);
    setMenuOpen(true);
    setSelectedUser(item);
  };

  const getAttendees = async () => {
    const result = await request(
      `pairingevent/attendees?pairingEventId=${pairingEvent._id}`
    );
    if (result.success) {
      setAttendees(result.attendees);
      setPercentages(result.percentages);
    }
  };

  const handleDialogClose = () => {
    getAttendees();
    setEditUserOpen(false);
    setRemoveUserOpen(false);
    setSelectedUser(null);
    setMenuOpen(false);
  };

  const handleEdit = () => {
    setEditUserOpen(true);
    setMenuOpen(false);
  };

  const handleSwap = () => {
    setSwapOpen(true);
  };

  const handleSwapClose = () => {
    getAttendees();
    setSwapOpen(false);
    setSelectedUser(null);
    setMenuOpen(false);
  };

  const handleTransfer = () => {
    setTransferOpen(true);
    setMenuOpen(false);
  };

  const handleRemove = () => {
    setRemoveUserOpen(true);
    setMenuOpen(false);
  };

  const handleConfirm = async () => {
    const body = {
      userId: selectedUser._id,
      eventId: pairingEvent.event._id,
    };
    const result = await request("events/removeattendee", "post", body);
    if (result.success) {
      toast.success("User removed from event");
      handleDialogClose();
    }
  };

  const renderAttendees = () => {
    if (attendees.length > 0) {
      return (
        <Grid container direction="column">
          <Grid item style={{ marginBottom: -20 }}>
            <Grid container direction="row" alignItems="center">
              <Grid item xs={6}>
                <Typography variant="button">name</Typography>
              </Grid>
              <Grid
                item
                xs={4}
                style={{ display: "flex", justifyContent: "center" }}
              >
                <Typography variant="button" align="center">
                  checked in
                </Typography>
              </Grid>
              <Grid
                item
                xs={1}
                style={{ display: "flex", justifyContent: "center" }}
              ></Grid>
            </Grid>
          </Grid>
          {attendees.map((item, i) => {
            return (
              <Grid item key={item._id}>
                <Grid container direction="row" alignItems="center">
                  <Grid
                    item
                    xs={6}
                    style={{ display: "flex", flexDirection: "row" }}
                  >
                    {item?.incompleteProfile ? <PriorityHighIcon /> : <></>}
                    <Typography>
                      {item.profile?.firstName} {item.profile?.lastName}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={4}
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <Checkbox
                      checked={item.checkedIn}
                      onChange={() => handleCheck(i)}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={1}
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <MoreVertIcon
                      onClick={(event) => handleMenuOpen(event, item)}
                      style={{ cursor: "pointer" }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            );
          })}
          <Menu
            anchorEl={anchor}
            open={menuOpen}
            onClose={() => setMenuOpen(false)}
          >
            <MenuItem onClick={handleEdit}>Edit</MenuItem>
            <MenuItem onClick={handleSwap}>Swap</MenuItem>
            {ticketingEnabled && (
              <MenuItem onClick={handleTransfer}>Transfer</MenuItem>
            )}
            <MenuItem onClick={handleRemove}>Remove Attendee</MenuItem>
          </Menu>
          {/* <EditUserDialog
            open={editUserOpen}
            close={handleDialogClose}
            user={selectedUser}
          /> */}
          <EditProfileDialog
            open={editUserOpen}
            close={handleDialogClose}
            user={selectedUser}
            eventId={pairingEvent?.event?._id}
          />
          {/* <AssignUserEvent
            open={removeUserOpen}
            close={handleDialogClose}
            user={selectedUser}
            action="remove"
          /> */}
        </Grid>
      );
    } else {
      return (
        <Typography>
          No attendees in database. Try syncing with Eventbrite
        </Typography>
      );
    }
  };

  return (
    <>
      <Grid container direction="column" spacing={3}>
        <Grid
          item
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="subtitle2">
            Checked In:{" "}
            {percentages?.totalCheckedIn ? percentages.totalCheckedIn : ""}
          </Typography>
          <Typography variant="subtitle2">
            Boys: {percentages?.boysCheckedIn ? percentages.boysCheckedIn : ""}
          </Typography>
          <Typography variant="subtitle2">
            Girls:{" "}
            {percentages?.girlsCheckedIn ? percentages.girlsCheckedIn : ""}
          </Typography>
        </Grid>
        <Grid item>{renderAttendees()}</Grid>
        <Dialog open={removeUserOpen} onClose={() => setRemoveUserOpen(false)}>
          <DialogTitle>Please confirm</DialogTitle>
          <DialogContent>
            <Typography>
              Are you sure you want to remove{" "}
              <strong>
                {selectedUser?.profile?.firstName}{" "}
                {selectedUser?.profile?.lastName}
              </strong>{" "}
              from the event?
            </Typography>
            {ticketingEnabled ? (
              <Typography style={{ paddingTop: 20 }}>
                Removing an attendee here will <strong>not</strong> issue a
                refund. If the ticket was purchased through this system, please
                refund via Users → Search Attendee. From there, you can also
                remove them from the event. Note: if you remove them here,
                ticket availability will update on this system and any linked
                platforms. (similar to refunds)
              </Typography>
            ) : null}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setRemoveUserOpen(false)}>Cancel</Button>
            <Button onClick={handleConfirm}>Confirm</Button>
          </DialogActions>
        </Dialog>
        <SwapDialog
          open={swapOpen}
          close={handleSwapClose}
          user={selectedUser}
        />
        <TransferDialog
          open={transferOpen}
          close={() => {
            setTransferOpen(false);
            getAttendees();
          }}
          user={selectedUser}
        />
      </Grid>
    </>
  );
};

export default AttendeeList;
